// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pricing-page-ChYnc {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Pricing-wrap-JBcZF {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.Pricing-sec-aPDIS {
  padding: 56px 0;
}

.Pricing-alt-dQclf {
  background: #f7f8f9;
}

.Pricing-h2-UImgP {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 8px;
}

.Pricing-h2Left-A0KJa {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

.Pricing-lead-MT8WK {
  text-align: center;
  color: var(--muted);
  font-size: 17px;
  margin: 0 auto 34px;
  max-width: 600px;
  line-height: 1.55;
}

/* Fee cards */

.Pricing-feeGrid-IQAV_ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

.Pricing-feeCard-XUm3L {
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 28px 26px;
  background: #fff;
  text-align: center;
}

.Pricing-feeBig-lQOYH {
  font-size: 46px;
  font-weight: 800;
  color: var(--red);
  line-height: 1;
  margin-bottom: 10px;
}

.Pricing-feeTitle-DKNlD {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 8px;
}

.Pricing-feeText-zOA6F {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Worked example */

.Pricing-example-WbgAq {
  max-width: 480px;
  margin: 0 auto;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 28px;
  background: #fff0ef;
}

.Pricing-exampleTitle-QfG2Y {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 16px;
  text-align: center;
}

.Pricing-exampleRows-juIA3 {
  list-style: none;
  margin: 0;
  padding: 0;
}

.Pricing-exampleRows-juIA3 li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 9px 0;
  font-size: 15px;
  color: var(--muted);
  border-bottom: 1px dashed #f3c9cb;
}

.Pricing-exampleTotal-iX6fu {
  font-weight: 800;
  font-size: 18px;
  color: var(--ink);
  border-bottom: none;
  padding-top: 14px;
}

.Pricing-exampleNote-oYhJZ {
  margin: 14px 0 0;
  font-size: 12px;
  color: var(--muted);
  text-align: center;
}

/* Calculation cards */

.Pricing-calcGrid-iiIYY {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
}

.Pricing-calcCard-mGuKr {
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px 20px;
  background: #fff;
}

.Pricing-calcCard-mGuKr h3 {
  font-size: 16px;
  font-weight: 800;
  margin: 0 0 8px;
}

.Pricing-calcCard-mGuKr p {
  font-size: 14px;
  line-height: 1.5;
  color: var(--muted);
  margin: 0;
}

/* Cancellation */

.Pricing-cancelCard-onK4Z {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.Pricing-cancelText-U_aaK {
  font-size: 16px;
  line-height: 1.6;
  color: var(--muted);
  margin: 12px 0 0;
}

.Pricing-cancelList-JBnb5 {
  list-style: none;
  padding: 0;
  margin: 18px auto 0;
  max-width: 560px;
  text-align: left;
}

.Pricing-cancelList-JBnb5 li {
  position: relative;
  padding: 10px 0 10px 28px;
  font-size: 16px;
  line-height: 1.55;
  color: var(--ink);
  border-bottom: 1px solid var(--line);
}

.Pricing-cancelList-JBnb5 li:last-child {
  border-bottom: 0;
}

.Pricing-cancelList-JBnb5 li::before {
  content: '✓';
  position: absolute;
  left: 0;
  top: 10px;
  color: #16a34a;
  font-weight: 700;
}

.Pricing-inlineLink-Dw_Ip {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.Pricing-inlineLink-Dw_Ip:hover {
  text-decoration: underline;
}

/* Promo */

.Pricing-promoCard-sd4SX {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 28px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 30px 32px;
  background: #e4f6f3;
}

.Pricing-promoText-hKvfg {
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0;
  max-width: 640px;
}

.Pricing-promoBtn-XB7l4 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 48px;
  padding: 13px 24px;
  border-radius: 14px;
  background: var(--green);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.Pricing-promoBtn-XB7l4:hover {
  background: var(--green-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

@media (max-width: 900px) {
  .Pricing-feeGrid-IQAV_ {
    grid-template-columns: 1fr;
  }
  .Pricing-calcGrid-iiIYY {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 680px) {
  .Pricing-sec-aPDIS {
    padding: 44px 0;
  }
  .Pricing-calcGrid-iiIYY {
    grid-template-columns: 1fr;
  }
  .Pricing-promoCard-sd4SX {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    text-align: center;
  }
}

@media (prefers-color-scheme: dark) {
  .Pricing-page-ChYnc {
    background: #14171a;
    color: #f3f4f6;
  }
  .Pricing-alt-dQclf {
    background: #1a1e22;
  }
  .Pricing-h2-UImgP,
  .Pricing-h2Left-A0KJa,
  .Pricing-feeTitle-DKNlD,
  .Pricing-exampleTitle-QfG2Y,
  .Pricing-exampleTotal-iX6fu,
  .Pricing-calcCard-mGuKr h3 {
    color: #f3f4f6;
  }
  .Pricing-lead-MT8WK,
  .Pricing-feeText-zOA6F,
  .Pricing-exampleRows-juIA3 li,
  .Pricing-exampleNote-oYhJZ,
  .Pricing-cancelText-U_aaK,
  .Pricing-promoText-hKvfg,
  .Pricing-calcCard-mGuKr p {
    color: #9aa3ad;
  }
  .Pricing-feeCard-XUm3L,
  .Pricing-calcCard-mGuKr {
    background: #1d2125;
    border-color: #2c3137;
  }
  .Pricing-example-WbgAq {
    background: rgba(232, 35, 43, 0.12);
    border-color: #2c3137;
  }
  .Pricing-example-WbgAq .Pricing-exampleRows-juIA3 li {
    border-bottom-color: rgba(232, 35, 43, 0.3);
  }
  .Pricing-promoCard-sd4SX {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/pricing/Pricing.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,cAAc;;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;;AACnB;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;;AACjB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;;AACA;EACE,gBAAgB;AAClB;;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;;AACV;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,0BAA0B;EAC1B,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;;IAME,cAAc;EAChB;EACA;;;;;;;IAOE,cAAc;EAChB;EACA;;IAEE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 8px;\n}\n.h2Left {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.lead {\n  text-align: center;\n  color: var(--muted);\n  font-size: 17px;\n  margin: 0 auto 34px;\n  max-width: 600px;\n  line-height: 1.55;\n}\n\n/* Fee cards */\n.feeGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-bottom: 32px;\n}\n.feeCard {\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 28px 26px;\n  background: #fff;\n  text-align: center;\n}\n.feeBig {\n  font-size: 46px;\n  font-weight: 800;\n  color: var(--red);\n  line-height: 1;\n  margin-bottom: 10px;\n}\n.feeTitle {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.feeText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Worked example */\n.example {\n  max-width: 480px;\n  margin: 0 auto;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 28px;\n  background: #fff0ef;\n}\n.exampleTitle {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 16px;\n  text-align: center;\n}\n.exampleRows {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.exampleRows li {\n  display: flex;\n  justify-content: space-between;\n  padding: 9px 0;\n  font-size: 15px;\n  color: var(--muted);\n  border-bottom: 1px dashed #f3c9cb;\n}\n.exampleTotal {\n  font-weight: 800;\n  font-size: 18px;\n  color: var(--ink);\n  border-bottom: none;\n  padding-top: 14px;\n}\n.exampleNote {\n  margin: 14px 0 0;\n  font-size: 12px;\n  color: var(--muted);\n  text-align: center;\n}\n\n/* Calculation cards */\n.calcGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n}\n.calcCard {\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 22px 20px;\n  background: #fff;\n}\n.calcCard h3 {\n  font-size: 16px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.calcCard p {\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Cancellation */\n.cancelCard {\n  max-width: 720px;\n  margin: 0 auto;\n  text-align: center;\n}\n.cancelText {\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 12px 0 0;\n}\n.cancelList {\n  list-style: none;\n  padding: 0;\n  margin: 18px auto 0;\n  max-width: 560px;\n  text-align: left;\n}\n.cancelList li {\n  position: relative;\n  padding: 10px 0 10px 28px;\n  font-size: 16px;\n  line-height: 1.55;\n  color: var(--ink);\n  border-bottom: 1px solid var(--line);\n}\n.cancelList li:last-child {\n  border-bottom: 0;\n}\n.cancelList li::before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  top: 10px;\n  color: #16a34a;\n  font-weight: 700;\n}\n.inlineLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.inlineLink:hover {\n  text-decoration: underline;\n}\n\n/* Promo */\n.promoCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  flex-wrap: wrap;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 30px 32px;\n  background: #e4f6f3;\n}\n.promoText {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0;\n  max-width: 640px;\n}\n.promoBtn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 48px;\n  padding: 13px 24px;\n  border-radius: 14px;\n  background: var(--green);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background 0.16s, transform 0.16s;\n}\n.promoBtn:hover {\n  background: var(--green-d);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 900px) {\n  .feeGrid {\n    grid-template-columns: 1fr;\n  }\n  .calcGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .calcGrid {\n    grid-template-columns: 1fr;\n  }\n  .promoCard {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .h2Left,\n  .feeTitle,\n  .exampleTitle,\n  .exampleTotal,\n  .calcCard h3 {\n    color: #f3f4f6;\n  }\n  .lead,\n  .feeText,\n  .exampleRows li,\n  .exampleNote,\n  .cancelText,\n  .promoText,\n  .calcCard p {\n    color: #9aa3ad;\n  }\n  .feeCard,\n  .calcCard {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .example {\n    background: rgba(232, 35, 43, 0.12);\n    border-color: #2c3137;\n  }\n  .example .exampleRows li {\n    border-bottom-color: rgba(232, 35, 43, 0.3);\n  }\n  .promoCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Pricing-page-ChYnc`,
	"wrap": `Pricing-wrap-JBcZF`,
	"sec": `Pricing-sec-aPDIS`,
	"alt": `Pricing-alt-dQclf`,
	"h2": `Pricing-h2-UImgP`,
	"h2Left": `Pricing-h2Left-A0KJa`,
	"lead": `Pricing-lead-MT8WK`,
	"feeGrid": `Pricing-feeGrid-IQAV_`,
	"feeCard": `Pricing-feeCard-XUm3L`,
	"feeBig": `Pricing-feeBig-lQOYH`,
	"feeTitle": `Pricing-feeTitle-DKNlD`,
	"feeText": `Pricing-feeText-zOA6F`,
	"example": `Pricing-example-WbgAq`,
	"exampleTitle": `Pricing-exampleTitle-QfG2Y`,
	"exampleRows": `Pricing-exampleRows-juIA3`,
	"exampleTotal": `Pricing-exampleTotal-iX6fu`,
	"exampleNote": `Pricing-exampleNote-oYhJZ`,
	"calcGrid": `Pricing-calcGrid-iiIYY`,
	"calcCard": `Pricing-calcCard-mGuKr`,
	"cancelCard": `Pricing-cancelCard-onK4Z`,
	"cancelText": `Pricing-cancelText-U_aaK`,
	"cancelList": `Pricing-cancelList-JBnb5`,
	"inlineLink": `Pricing-inlineLink-Dw_Ip`,
	"promoCard": `Pricing-promoCard-sd4SX`,
	"promoText": `Pricing-promoText-hKvfg`,
	"promoBtn": `Pricing-promoBtn-XB7l4`
};
module.exports = ___CSS_LOADER_EXPORT___;
